import React, { useState, useEffect, useRef } from 'react';

// function CountUpComponent({ targetNumber }) {
//     const [count, setCount] = useState(0);

//     useEffect(() => {
//         const interval = setInterval(() => {
//             if (count < targetNumber) {
//                 setCount(prevCount => prevCount + 1);
//             }
//         }, targetNumber > 500 ? 0 : 20); // Change the interval duration as needed (in milliseconds)

//         return () => {
//             clearInterval(interval);
//         };
//     }, [count, targetNumber]);

//     return <span>{typeof targetNumber === "number" ? count : targetNumber}</span>
// }

import { Text } from '@chakra-ui/react';

function CountUpComponent({ targetNumber, duration = 500 }) {
	const [count, setCount] = useState(0);
	// What is on screen right now. A changed target counts on from here: it used to
	// reset to 0 and climb again, so a list that lost one lead flashed 0 and took half
	// a second to show the new total.
	const shownRef = useRef(0);

	useEffect(() => {
		if (typeof targetNumber !== 'number' || targetNumber < 0) return undefined;

		const from = shownRef.current;
		let startTime = null;
		let frame;

		const animateCount = (currentTime) => {
			if (!startTime) startTime = currentTime; // Set the start time on the first frame

			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / duration, 1); // Clamp progress to [0, 1]

			const nextCount = Math.round(from + (targetNumber - from) * progress);

			shownRef.current = nextCount;
			setCount(nextCount);

			if (progress < 1) {
				frame = requestAnimationFrame(animateCount);
			}
		};

		frame = requestAnimationFrame(animateCount);

		return () => cancelAnimationFrame(frame);
	}, [targetNumber, duration]);

	return <span>{typeof targetNumber === 'number' ? count : targetNumber}</span>;
}

export default CountUpComponent;
